import React, { useEffect, useRef } from 'react'
import propTypes from 'prop-types'
import { Line } from 'react-chartjs-2'

import { buildChartjsDataProp } from './data'
import { buildChartJsOptionsProp } from './options'
import { legendPlugin } from './plugins/legend'
import { crosshairPlugin } from './plugins/crosshair'
import { fillCb } from './plugins/fillCb'

export const Projection = (props) => {
  const { datasets } = props
  const data = buildChartjsDataProp(datasets)
  const options = buildChartJsOptionsProp(props)
  const chartRef = useRef()

  useEffect(
    () => {
      chartRef && chartRef.current && chartRef.current.update()
    }
  , [props.chartType, props.timeValue])

  return (
    <section key='projection-chart' className='projection-chart'>
      <LegendTag />
      <div className='projection-chart__canvas relative'>
        <Line
          ref={chartRef}
          data={data}
          // Bug: Tsserver shows a type mismatch here
          // because we including plugins config in options
          options={options}
          plugins={[legendPlugin, crosshairPlugin, fillCb]}
        />
      </div>
      <TableTooltipTag />
    </section>
  )
}

// Chart js will render the legend inside of this tag.
const LegendTag = () =>
  <div id={`chart-legend`} />

// Chart js will render the tooltip inside of these tags.
const TableTooltipTag = () =>
  <>
    <div id={`table-tooltip`} className='chart-tooltip chart-tooltip--table' />
  </>

Projection.propTypes = {
  // The datasets prop should follow the chartjs `datasets`
  // definition: https://www.chartjs.org/docs/latest/charts/line.html#dataset-properties
  datasets: propTypes.arrayOf(propTypes.object),
  colors: propTypes.object.isRequired,
  stacked: propTypes.bool,
}
